import { graphql } from 'react-relay';

export const simpleLinkFragment = graphql`
    fragment SimpleLink_simpleLink on SimpleLink {
        label
        url
    }
`;
